import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from 'semantic-ui-react'

import { loadGenres } from '../Slice/GenreSlice'

export default function SearchGenre ({
  name = 'genres',
  icon = 'search',
  multiple = true,
  search = true,
  value,
  onChange,
  size = 7
}) {
  const dispatch = useDispatch()
  const { isLoading, list } = useSelector(state => state.genre)
  const { t } = useTranslation()

  useEffect(() => {
    dispatch(loadGenres({ limit: 300 }))
  }, [])

  const onDropdownChange = (e, data) => {
    if (typeof onChange === 'function') {
      onChange(e, data)
    }
  }

  return (
    <Form.Dropdown
      fluid
      icon={icon}
      label={t('genre.title')}
      loading={isLoading}
      multiple={multiple}
      name={name}
      options={list.length > 0 ? list.map((element) => ({
        key: element.id,
        text: element.name,
        value: element.id
      })) : []}
      placeholder={t('genre.search')}
      search={search}
      selection
      value={value}
      width={size}
      onChange={onDropdownChange}
    />
  )
}
